// extracted by mini-css-extract-plugin
module.exports = {"main":"Modal_main__obUor","retry":"Modal_retry__8eEs0","titleBtn":"Modal_titleBtn__yZqU6"};